import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import authService from "src/services/authService";
import { useSelector } from "src/store";
import { selectProfile } from "src/store/account";
import { selectIsUserCredentialValid } from "src/store/auth";

export const AuthGuard = () => {
    const location = useLocation();
    const userCredentialValid = useSelector(selectIsUserCredentialValid);
    const profile = useSelector(selectProfile);

    useEffect(() => {
        if (!userCredentialValid) {
            // AuthGuard kicks off the OAuth redirect to the IdP authorization endpoint,
            // which bounces back to /login with client_id/redirect_uri/state in the query string.
            void authService.initiateAuthFlow(location.pathname + location.search);
        }
    }, [userCredentialValid, location.pathname, location.search]);

    if (!userCredentialValid) {
        return null;
    }

    if (profile && !profile.profileCompleted) {
        return <Navigate to="/account/confirm" replace />;
    }

    return <Outlet />;
};
